import Alpine from 'alpinejs';
import focus from '@alpinejs/focus';
import collapse from '@alpinejs/collapse';
import './Presentation/Header';
import './Presentation/Slider';
import './GabWebCms/Gallery';

Alpine.data('newsletterPdfViewer', (pdfModuleUrl, workerUrl) => {
    let pdfDocument = null;

    return {
        url: '',
        pageNumber: 1,
        pageCount: 0,
        scale: 1,
        loading: false,
        error: false,
        errorMessage: '',
        async load(url) {
            this.url = url;
            this.loading = true;
            this.error = false;
            this.errorMessage = '';
            pdfDocument = null;
            this.pageNumber = 1;

            try {
                const pdfjsLib = await import(pdfModuleUrl);
                pdfjsLib.GlobalWorkerOptions.workerSrc = workerUrl;
                pdfDocument = await pdfjsLib.getDocument(this.url).promise;
                this.pageCount = pdfDocument.numPages;
                await this.renderPage();
            } catch (error) {
                this.error = true;
                this.errorMessage = error?.message || String(error);
                console.error('Newsletter PDF viewer failed:', error);
            } finally {
                this.loading = false;
            }
        },
        async renderPage() {
            if (!pdfDocument) {
                return;
            }

            const page = await pdfDocument.getPage(this.pageNumber);
            const canvas = this.$refs.canvas;
            const context = canvas.getContext('2d');
            const viewport = page.getViewport({ scale: this.scale });
            const ratio = window.devicePixelRatio || 1;

            canvas.width = viewport.width * ratio;
            canvas.height = viewport.height * ratio;
            canvas.style.width = `${viewport.width}px`;
            canvas.style.height = `${viewport.height}px`;
            context.setTransform(ratio, 0, 0, ratio, 0, 0);
            await page.render({ canvasContext: context, viewport }).promise;
        },
        previousPage() {
            if (this.pageNumber > 1) {
                this.pageNumber -= 1;
                this.renderPage();
            }
        },
        nextPage() {
            if (this.pageNumber < this.pageCount) {
                this.pageNumber += 1;
                this.renderPage();
            }
        },
        zoomOut() {
            this.scale = Math.max(0.5, this.scale - 0.25);
            this.renderPage();
        },
        zoomIn() {
            this.scale = Math.min(3, this.scale + 0.25);
            this.renderPage();
        },
    };
});

Alpine.plugin(focus);
Alpine.plugin(collapse);

// We use this to enable the AlpineJS debugger in the browser.
if (document.documentElement.dataset.debug != undefined) {
    window.Alpine = Alpine;
}

Alpine.start();
